var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: _vm.id,
        "aria-hidden": "true",
        "aria-labelledby": _vm.id,
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1"
      }
    },
    [
      _c("ValidationObserver", { ref: "messageObserver" }, [
        _c(
          "form",
          {
            attrs: { novalidate: "" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.onContinue.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-dialog-centered modal-lg",
                attrs: { role: "document" }
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "tag-badge" }, [
                        _c("span", { staticClass: "dot text-center" }, [
                          _c("em", {
                            staticClass:
                              "orange-icon orange-icon-badge-align fa fa-info-circle"
                          })
                        ]),
                        _c(
                          "span",
                          { staticClass: "tag-badge-title py-1 pl-2" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.message.titleDescription) + " "
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("span", { staticClass: "message-date" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$formatDate(
                                _vm.message.createDate,
                                _vm.$templateDate.longDateFormat
                              )
                            ) +
                            " "
                        )
                      ]),
                      _c("div", {
                        staticClass: "mt-2 message-description",
                        domProps: {
                          innerHTML: _vm._s(_vm.message.messageDescription)
                        }
                      }),
                      _vm.message.documentId
                        ? _c("div", { staticClass: "mt-4" }, [
                            _c(
                              "span",
                              {
                                staticClass: "item-download-file",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(
                                      _vm.message.documentId
                                    )
                                  }
                                }
                              },
                              [
                                _c("em", { staticClass: "fa fa-paperclip" }),
                                _c("span", [_vm._v("Descargar documento")])
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _c("div", { staticClass: "row mx-4" }, [
                    _c("div", {
                      staticClass: "dropdown-divider mt-0 pb-2 w-100 ml-1 mr-1"
                    }),
                    _c(
                      "div",
                      { staticClass: "col-md-6 text-left mt-2" },
                      [
                        _vm.showCertification
                          ? _c("ValidationProvider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function({ errors }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-control custom-checkbox checkbox-top-spacing ml-n2"
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.message.isCertified,
                                                  expression:
                                                    "message.isCertified"
                                                }
                                              ],
                                              staticClass:
                                                "custom-control-input",
                                              attrs: {
                                                id: "chkCertified",
                                                name: "chkCertified",
                                                type: "checkbox"
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.message.isCertified
                                                )
                                                  ? _vm._i(
                                                      _vm.message.isCertified,
                                                      null
                                                    ) > -1
                                                  : _vm.message.isCertified
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        _vm.message.isCertified,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.message,
                                                            "isCertified",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.message,
                                                            "isCertified",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.message,
                                                        "isCertified",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                  _vm.onChangeCerfified
                                                ]
                                              }
                                            }),
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "custom-control-label font regular",
                                                class: [
                                                  { "has-error": errors[0] }
                                                ],
                                                attrs: { for: "chkCertified" }
                                              },
                                              [
                                                _c("span", [
                                                  _c("em", {
                                                    staticClass: "ic-check"
                                                  })
                                                ]),
                                                _vm._v(
                                                  " Certifico que he leído este mensaje. "
                                                )
                                              ]
                                            ),
                                            errors[0]
                                              ? _c("error", {
                                                  attrs: {
                                                    message: "Campo Requerido.",
                                                    variant: "no-border ml-n1"
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2000625316
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-6 col-sm-12 text-right action-container"
                      },
                      [
                        _vm.showGoToHelpdesk
                          ? _c(
                              "action-button",
                              {
                                staticClass: "ml-2 px-4 w-auto",
                                attrs: {
                                  type: "button",
                                  variant: "outline-success close-border mr-1"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.goToHelpdesk()
                                  }
                                }
                              },
                              [_vm._v(" Ir a mis solcitudes ")]
                            )
                          : _vm._e(),
                        _c(
                          "action-button",
                          {
                            staticClass: "ml-2 px-4",
                            attrs: {
                              type: "submit",
                              variant: "outline-success close-border mr-n3"
                            }
                          },
                          [_vm._v(" Continuar ")]
                        )
                      ],
                      1
                    ),
                    _c("hr"),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "2rem",
                          border: "1px solid transparent"
                        }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }